import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  skillLevels: [],
  skillLevel: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  skillLevelsListGet: (state) => state.skillLevels,
  skillLevelGet: (state) => state.skillLevel,
  paginationGet: (state) => state.pagination,
};
const actions = {
  getSkillLevels({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`skills-levels?page=${page}`).then(
      (obj) => {
        var result = obj.data.skills_leveles;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("skillLevelsListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getSkillLevelById({ commit }, payload) {
    service.getFun(`skillLevels/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("getSkillLevelById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addSkillLevel({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `skills-levels/store`, null, {
        action: "getSkillLevels",
      })
      .then(
        (result) => {
          console.log(result, "add res");
          result
            ? commit("addSkillLevelStatus", result.success)
            : commit("addSkillLevelStatus", false);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editSkillLevel({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `skills-levels/edit/${payload.id}`,
        null,
        { action: "getSkillLevels" }
      )
      .then(
        (result) => {
          commit("editSkillLevelStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteSkillLevel({ commit }, payload) {
    console.log(payload, "id");
    service
      .postFun(null, `skills-levels/delete/${payload.payload}`, null, {
        action: "getSkillLevels",
      })
      .then(
        (result) => {
          commit("deleteSkillLevelStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  skillLevelsListSet(state, skillLevels) {
    state.skillLevels = skillLevels;
  },
  addSkillLevelStatus(state, Status) {
    state.addStatus = Status;
  },
  getSkillLevelById(state, skillLevel) {
    state.skillLevel = skillLevel;
  },
  editSkillLevelStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteSkillLevelStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
